/* eslint-disable import/no-anonymous-default-export */
import axios, { AxiosError } from "axios"
import useApi, { ActionResult, Api, Model, Query, Response } from "../common/hooks/useApi"
import { InfraccionesInfractor } from "../infracciones-infractores/useInfraccionesInfractoresAPI";
import { Infraccion } from "../infracciones/hooks/useInfraccionesAPI";
import { TitularVehiculo } from "../titulares-vehiculo/useTitularesVehiculoAPI";
import { Usuario } from "../usuarios/useUsuariosAPI";


export interface ConvenioPagoInfraccion {
    InfraccionId: number
    ConvenioPagoId: number
    Infraccion: Infraccion
}

export interface ConvenioPagoConfiguracion {
    porcentajes: string[]
    valorPagoUf:number
    valorGastosAdmin:number
}

export interface MontosConvenio {
    montosInfracciones: {
        [id: string]: {
            montoInfraccion: number
            montoGastosAdministrativos: number
        }
    }
    montoTotal: number
    porcentajeDescuento:number
}

export interface ConvenioPago extends Model {
    InfractorId: number
    Infractor: TitularVehiculo
    UsuarioId: number
    Usuario: Usuario
    PorcentajeDescuento: number
    MontoTotal: number
    ConvenioInfracciones?: ConvenioPagoInfraccion[]
    EstadoPago: ("PAGADA" | "IMPAGA" | "PAGO_PARCIAL")
    Vencimiento_Cuota1:Date
}
export interface NuevoConvenioRequest {
    CantidadCuotas: number
    PorcentajeDescuento: number
    CuitCuilTitular: string
    IdsInfracciones: number[]
}


const module = "ConvenioPago";
export default () => {
    const api = useApi({ module });
    return {
        delete: (id: number) => api.delete(id),
        list: (query: Query) => api.list!<ConvenioPago>(query),
        //api.list!<ConvenioPago>(query, [`UsuarioId=${idUsuario}`]),
        listInfraccionesInfractor: (query: Query) => api.list!<InfraccionesInfractor>(query, undefined, "InfraccionesInfractor()"),
        listInfraccionesCuitCuil: (query: Query, cuitCuil: string, mostrarVigentes:boolean) => api.list!<Infraccion>(query, [`cuitCuil=${cuitCuil}&mostrarVigentes=${mostrarVigentes}`], "InfraccionesCuitCuil()"),
        listInfraccionesConvenio: (query: Query, idConvenio: number) => api.list!<Infraccion>(query, [`idConvenio=${idConvenio}`], `Infracciones()`),
        getMontos: async (data: NuevoConvenioRequest, mostrarVigentes:boolean) => {
            try {
                const response = await api.axiosInstance.post<MontosConvenio>(`${module}/VerMontos()?mostrarVigentes=${mostrarVigentes}`, data);
                return {
                    data: { value: response.data }
                }
            } catch (error: any | AxiosError) {
                return {
                    error
                };
            }
        },
        generar: async (data: NuevoConvenioRequest, mostrarVigentes:boolean) => {
            try {
                const response = await api.axiosInstance.post<number>(`${module}/Generar()?mostrarVigentes=${mostrarVigentes}`, data);
                return {
                    data: response.data
                }
            } catch (error: any | AxiosError) {
                return {
                    error
                };
            }
        },
        pdfDownload: async (id: number) => {
            //window.location.href = `${api.baseAxiosConfig.baseURL}/${module}/Documento/${id}`


            try {
                const response = await api.axiosInstance.request<Blob>({
                    url: `${module}/Documento/${id}`,
                    method: 'POST',
                    responseType: 'blob'
                });
                const url = URL.createObjectURL(new Blob([response.data], {type:'application/pdf'}));
                return { data: url }
            } catch (error: any | AxiosError) {
                return {
                    error
                };
            }
        },
        getDescuentos: async () => {
            try {
                const response = await api.axiosInstance.post<ConvenioPagoConfiguracion>(`/ConvenioPago/ConfiguracionConvenioUsuario`);
                return {
                    data: { value: response.data }
                }
            } catch (error: any | AxiosError) {
                return {
                    error
                };
            }
        },
        verEstadoCuotas: async (convenioId: number) => {
            try {
                const response = await api.axiosInstance.get(`${module}/estadocuotas/${convenioId}`);
                return {
                    data: response.data
                }
            } catch (error: any | AxiosError) {
                return {
                    error
                };
            }
        },
        regenerarCuotasVencidas: async (convenioId: number) => {
            try {
                const response = await api.axiosInstance.post(`${module}/regenerar/${convenioId}`);
                return true;
            } catch (error: any | AxiosError) {
                return false;
            }
        }

    };
}
